import script from "./VideoUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./VideoUploadModal.vue?vue&type=style&index=0&id=5022971b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5022971b"]])

export default __exports__